<p [ngClass]="{bold}"><ng-content></ng-content></p>
